"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPercent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _icon = require("./components/icon.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  color: _propTypes.string
} : {};
var defaultProps = {
  color: '#566'
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["className", "color"]);

  return (0, _core.jsx)("div", {
    className: className
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M14.5 11a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm2.207-9.707a1 1 0 010 1.414l-14 14a1 1 0 11-1.414-1.414l14-14a1 1 0 011.414 0zM14.5 13a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM3.5 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    id: "percent_svg__a"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M0 0h48v48H0z"
  }), (0, _core.jsx)("g", {
    transform: "translate(15 15)"
  }, (0, _core.jsx)("mask", {
    id: "percent_svg__b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#percent_svg__a"
  })), (0, _core.jsx)("use", {
    fill: "#889",
    fillRule: "nonzero",
    xlinkHref: "#percent_svg__a"
  }), (0, _core.jsx)("g", {
    mask: "url(#percent_svg__b)",
    fill: color
  }, (0, _core.jsx)("path", {
    d: "M-15-15h48v48h-48z"
  }))))));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = propTypes : void 0;
Icon.defaultProps = defaultProps;
var IconPercent = (0, _stylitas.styled)(Icon)(_templateObject(), _icon.iconBase);
exports.IconPercent = IconPercent;
IconPercent.displayName = 'IconPercent';